import React, { FunctionComponent } from "react";

import { IconCode } from "@multiweb/types/contracts";
import { Cursor } from "@multiweb/types/multiweb";
import { QAProps } from "@multiweb/types/react";
import { ComponentTheme } from "@multiweb/uiShared/ComponentTheme";

/**
 * Typ akce. V DropdownAction se použivá jako nepovinný rozlišovací element.
 */
export type DropdownActionType = "main" | "other" | string;

/**
 * Akce na kliknutí
 */
export type DropdownAction = {
    /** Popisek akce */
    title: string;
    /** Ikona tlačítka */
    icon?: IconCode;
    /** Text na tlačítku */
    text?: string;
    /** Samotná akce na kliknutí */
    onClick?: ClickAction;
    /** Aktivnost akce */
    disabled?: boolean;
    /** Typ akce, slouží k rozlišení typu akce pří kliknutí. Typ akce se předa při kliku jako argument slouží k rozlišení
     * pokud by se používal jeden callback pro více akci */
    type?: DropdownActionType;
};

/** Akce na kliknutí */
export type ClickAction = (e: React.MouseEvent<HTMLElement, MouseEvent>, actionType?: DropdownActionType, customData?: any) => boolean | void;

export type DropdownItemBaseProps = {
    /** Téma tlačítka */
    theme?: ComponentTheme;
    /** Zobrazeny cursor na tlačítku */
    cursor?: Cursor;
    /** Hlavní akce obsahující callback na kliknutí, text tlačítka, title na najetí myší, aktivnost a ikonu */
    clickAction?: DropdownAction;
} & QAProps;

/**
 * Typ pro loaderRenderer Dropdownu.
 */
export type DropdownLoaderRenderer = FunctionComponent<DropdownSizesProps>;

/** Typ pro dropdown komponenty, které podporují načítání. */
export type DropdownLoadingProps = {
    /** Informace o tom, zda probiha loading */
    isLoading?: boolean;
    /** Komponenta, která zobrazuje loading skeleton. Slouží k nahrazení defaultního skeletonu. */
    loaderRenderer?: DropdownLoaderRenderer;
};

/** Typ pro dropdown komponenty, které podporují velikosti a maximální velikosti. */
export type DropdownSizesProps = {
    /** Určuje výšku Dropdownu. Doporučené jednotky jsou px, vw, vh. */
    height?: string | number;
    /** Určuje maximální výšku Dropdownu. Doporučené jednotky jsou px, vw, vh. */
    maxHeight?: string | number;
    /** Určuje šířku Dropdownu. Doporučené jednotky jsou px, vw, vh. */
    width?: string | number;
    /** Určuje maximální šířku Dropdownu. Doporučené jednotky jsou px, vw, vh. */
    maxWidth?: string | number;
};

/** Typ pro state maximálních velikostí. */
export interface IMaxSizes {
    /** Maximální výška. */
    height: number | string;
    /** Maximální šířka. */
    width: number | string;
}
